import OfficesApi from "@/api/offices";
import { SelectBox } from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";
import { FC, useState } from "react";

interface OfficeSelectorProps {
  defaultValue?: any;
  value?: any;
  onChange?: (value: any, data: Office) => void;
  error?: string;
}

type Office = {
  office_id: number;
  office_name: string;
};

const OfficeSelector: FC<OfficeSelectorProps> = ({
  defaultValue,
  value,
  onChange,
  error,
}) => {
  const isControlled = value !== undefined;

  const [stateValue, setStateValue] = useState<number | undefined>(
    defaultValue
  );

  const _value = isControlled ? value : stateValue;

  const { data: offices, isLoading } = useQuery({
    queryKey: ["offices", "list"],
    queryFn: () => OfficesApi.getOffices(),
  });

  const handleChange = (value: number, data: Office) => {
    if (!isControlled) {
      setStateValue(value);
    }

    onChange?.(value, data);
  };

  const options = offices?.map((office: Office) => ({
    label: office?.office_name,
    value: office?.office_id,
    data: office,
  }));

  return (
    <>
      <SelectBox
        key={isLoading ? 1 : 2}
        value={_value}
        onChange={handleChange}
        error={error}
        size="sm"
        variant="outlined"
        label="Office"
        placeholder="Select or enter an office"
        data={options}
        clearable={true}
        searchable={true}
        allowCustomValue={true}
        required={true}
        disabled={isLoading}
      />
    </>
  );
};

export default OfficeSelector;
